import Icon from 'components/shared/Icon/Icon';

const SlideHeader = ({ title }) => (
  <div className="relative overflow-hidden rounded-xl bg-gradient-to-r from-[#0093C4] to-[#00B8E8] px-5 py-3">
    <div className="absolute -right-4 -top-4 h-24 w-24 rounded-full bg-white/5" />
    <div className="absolute -bottom-6 -left-6 h-20 w-20 rounded-full bg-white/5" />
    <div className="absolute right-14 top-8 h-3 w-3 rounded-full bg-white/20" />
    <div className="absolute left-24 top-1 h-2 w-2 rounded-full bg-white/15" />

    <div className="relative flex items-center justify-between">
      <span className="text-sm font-600 text-white">{title}</span>
      <div className="flex h-8 w-8 items-center justify-center rounded-full bg-white/20">
        <Icon icon="stethoscope-mono" size={16} color="white" />
      </div>
    </div>
  </div>
);

export default SlideHeader;
